interface AudienceCard {
  role: string;
  tagline: string;
  bullets: string[];
}

const CARDS: AudienceCard[] = [
  {
    role: 'For Coaches',
    tagline: 'Build templates once. Scale precision feedback to every athlete.',
    bullets: [
      'Define movement templates with annotated phases and scoring thresholds',
      'Manage all your athletes and track their evaluation history in one place',
      'Monitor team-wide progress and spot weaknesses across sessions',
      'Deliver consistent, data-backed feedback instead of subjective notes',
    ],
  },
  {
    role: 'For Athletes',
    tagline: 'Understand exactly what to fix — and see it improve over time.',
    bullets: [
      'Get instant, detailed feedback after every recorded session',
      'See your scores across phases and body regions, not just a single number',
      'Track improvement over time with objective evaluation history',
      "Train with confidence knowing your coach's benchmark is baked in",
    ],
  },
];

export default function WhoItsFor() {
  return (
    <section className="py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-14">
          <p
            className="mb-3 text-xs font-medium uppercase tracking-widest"
            style={{ color: 'var(--color-brand-primary)', letterSpacing: '0.12em' }}
          >
            Who it's for
          </p>
          <h2 className="text-h1" style={{ color: 'var(--color-text-primary)' }}>
            Built for the coach-athlete relationship.
          </h2>
        </div>

        {/* Two-column grid */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {CARDS.map((card) => (
            <article
              key={card.role}
              className="rounded-2xl p-8"
              style={{
                background: 'var(--color-surface-raised-2)',
                border: '1px solid var(--color-border-subtle)',
              }}
            >
              {/* Role label */}
              <p
                className="mb-2 text-xs font-semibold uppercase tracking-widest"
                style={{
                  color: 'var(--color-brand-primary)',
                  letterSpacing: '0.12em',
                }}
              >
                {card.role}
              </p>

              <h3 className="text-h2 mb-5" style={{ color: 'var(--color-text-primary)' }}>
                {card.tagline}
              </h3>

              <ul className="space-y-3">
                {card.bullets.map((bullet) => (
                  <li key={bullet} className="flex items-start gap-3">
                    {/* Bullet dot */}
                    <span
                      className="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full"
                      style={{ backgroundColor: 'var(--color-brand-primary)' }}
                      aria-hidden
                    />
                    <span
                      className="text-body-md"
                      style={{ color: 'var(--color-text-secondary)' }}
                    >
                      {bullet}
                    </span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
